import { Capacitor } from '@capacitor/core';

export interface NativeOnlyOptions<T = unknown> {
  fallback?: T;
  log?: boolean;
  throwOnWeb?: boolean;
}

export function NativeOnly<T = unknown>(options: NativeOnlyOptions<T> = {}) {
  const { fallback, log = true, throwOnWeb = false } = options;

  return function (target: object, propertyKey: string, descriptor: PropertyDescriptor): PropertyDescriptor {
    const originalMethod = descriptor.value;

    descriptor.value = async function (...args: unknown[]) {
      const isNative = Capacitor.isNativePlatform();

      if (!isNative) {
        if (log) {
          console.warn(`[NativeOnly] "${propertyKey}" skipped on web platform.`);
        }

        if (throwOnWeb) {
          throw new Error(`[NativeOnly] "${propertyKey}" is unavailable on web.`);
        }

        return fallback;
      }

      return originalMethod.apply(this, args);
    };

    return descriptor;
  };
}
